<template>
  <div>
    <div v-if="clearance === roles.clubAdmin">
      <select
        id="selectTeam"
        class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
        v-model="teamId"
        :class="teamId ? 'tw-font-medium' : 'tw-font-normal'"
      >
        <option disabled selected :value="null">Select a team</option>
        <option
          v-for="{ _id, name, ageLvl } in teams"
          :label="`${name} (${ageLvl})`"
          :key="_id"
          :value="_id"
        >
          {{ `${name} (${ageLvl})` }}
        </option>
      </select>
    </div>
    <div v-if="!matches.length" class="tw-py-2.5">
      <div class="tw-p-5 tw-leading-6 tw-bg-white tw-border tw-border-gray-200 tw-shadow-md">
        Sorry, but it looks like your league is still finalising the draw. Please check back soon or
        contact your Club or League.
      </div>
    </div>
    <div v-if="clearance === roles.clubAdmin && matches.length">
      <select
        id="selectACompetition"
        class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
        v-model="competitionId"
        :class="competitionId ? 'tw-font-medium' : 'tw-font-normal'"
      >
        <option disabled selected :value="null">Select a competition</option>
        <option v-for="{ _id, name } in competitions()" :label="name" :key="_id" :value="_id">
          {{ name }}
        </option>
      </select>
    </div>

    <div v-if="upcomingMatches.length">
      <h3 class="tw-py-5 tw-text-lg tw-font-bold">Upcoming Matches</h3>
      <el-col v-for="match in upcomingMatches" :key="match._id">
        <match @open_team="openTeam" :match="match" />
      </el-col>
    </div>

    <div v-if="previousMatches.length">
      <h3 class="tw-py-5 tw-text-lg tw-font-bold">Previous Matches</h3>
      <el-col v-for="match in previousMatches" :key="match._id">
        <match :match="match" @open_team="openTeam" />
      </el-col>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Match from "../../components/MatchCard.vue";
import { roles, currentSeason } from "../../utils/constants";

export default {
  name: "TeamMatches",
  components: {
    Match,
  },
  data() {
    return {
      roles,
      teams: [],
      teamId: null,
      matches: [],
      filteredMatches: [],
      competitionId: null,
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);

    if (this.clearance === roles.clubAdmin) {
      // Check for current Season Active Teams
      this.$http.get(`/nrl/api/v1/admin/club/teams?season=${currentSeason}`).then((res) => {
        this.teams = res.data.data;
      });
      this.teamId = this.$store.state.app.selectedTeamId;
      this.$store.commit("root/loading", false);
    } else if (this.clearance === roles.teamAdmin) {
      this.teamId = this.$store.getters["user/activeRole"].entity._id;
      this.$http.get(`nrl/api/v1/admin/teams/${this.teamId}/matches`).then((res) => {
        this.matches = res.data.data;

        // filter out tba or bye game
        if (this.matches && this.matches.length) {
          this.matches = this.matches.filter((x) => !x.meta || (!x.meta.isTba && !x.meta.isBye));
        }

        this.filteredMatches = this.matches;
      });
    } else if (this.clearance === roles.gamedayAdmin) {
      // this.$http.get("/nrl/api/v1/admin/club/teams").then((res) => {
      //   this.teams = res.data.data;
      // });

      this.teamId = this.$store.state.app.selectedTeamId;
      this.$http.get(`/nrl/api/v1/admin/gamedayadmin/`).then((res) => {
        this.matches = res.data.data;
        if (this.matches && this.matches.length) {
          this.matches = this.matches.filter((x) => !x.meta || (!x.meta.isTba && !x.meta.isBye));
        }

        this.filteredMatches = this.matches;
      });

      this.$store.commit("root/loading", false);
    }
  },
  methods: {
    openTeam(data) {
      const { team, match } = data;

      if (this.clearance === roles.gamedayAdmin) {
        // open the team thatsuits
        this.$router.push({
          name: "teamLists.management",
          params: {
            teamId: team._id,
            matchId: match._id,
          },
        });
      } else {
        this.managePlayers(match._id);
      }
    },
    competitions() {
      if (this.matches.length) {
        return _.chain(this.matches).map("competition").uniqBy("_id").sortBy("name")
          .values();
      }
      return [];
    },
    matchTime(dateTime) {
      return this.dayjs(dateTime).format("h:mm a");
    },
    matchDate(dateTime) {
      return this.dayjs(dateTime).format("dddd Do MMMM");
    },
    managePlayers(matchId) {
      const match = this.matches.find(x => x._id === matchId);

      if (match && match.status !== "pre-game") {
        this.$customError(`Match has been set to ${match.status}.`);
        return;
      }

      if (match && Math.abs(this.dayjs().diff(match.dateTime, "days", true)) > 8) {
        this.$customError("Match has exceeded 8 days");
        return;
      }

      this.$router.push({
        name: "teamLists.management",
        params: {
          teamId: this.teamId,
          matchId,
        },
      });
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    upcomingMatches() {
      const time = this.dayjs().subtract(12, "hours").valueOf();
      return _.orderBy(
        this.filteredMatches.filter(x => x.dateTime >= time),
        "dateTime"
      );
    },
    previousMatches() {
      const time = this.dayjs().subtract(12, "hours").valueOf();
      return _.orderBy(
        this.filteredMatches.filter(x => x.dateTime < time),
        "dateTime"
      );
    },
  },
  watch: {
    teamId: {
      immediate: true,
      handler(val) {
        this.$store.commit("root/loading", true);
        // reset competition id if user select another team
        if (val !== this.$store.state.app.selectedTeamId && val !== null) {
          this.$store.commit("app/selectTeam", val);
          this.$store.commit("app/selectCompetition", null);
          this.competitionId = null;
        }

        if (val) {
          this.$http.get(`nrl/api/v1/admin/teams/${val}/matches`).then((res) => {
            this.matches = res.data.data;
            // filter out tba or bye game
            if (this.matches && this.matches.length) {
              this.matches = this.matches.filter(
                (x) => !x.meta || (!x.meta.isTba && !x.meta.isBye)
              );
            }
            this.competitionId = this.$store.state.app.selectedCompetitionId;
            this.filteredMatches = this.competitionId
              ? this.matches.filter((match) => match.competition._id === this.competitionId)
              : this.matches;
            this.$store.commit("root/loading", false);
          });
        }
      },
    },
    competitionId: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.$store.commit("app/selectCompetition", val);
          this.filteredMatches = this.matches.filter((x) => x.competition._id === val);
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
h3 {
  text-align: center;
}
.el-col .el-col-24 {
  margin: 5px 0px;
}
select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
}
</style>
